import "./personal.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { assetsMap } from "../../model/assets";

const date = new Date();
window.isWinter = [11,0].includes(date.getMonth());

const image = [
    "./assets/website/remyVitaliFace.jpeg",         //JAN
    "./assets/website/remyVitali.jpeg",             //FEV
    "./assets/website/remyVitaliFace.jpeg",         //MAR
    "./assets/website/remyVitaliAmand.jpeg",        //AVR
    "./assets/website/remyVitaliPortrait.jpeg",     //MAI
    "./assets/website/remyVitali.jpeg",             //JUIN
    "./assets/website/remyVitaliPortrait.jpeg",     //JUIL
    "./assets/website/remyVitaliAmand.jpeg",        //AOUT
    "./assets/website/remyVitaliPortrait.jpeg",     //SEP
    "./assets/website/remyVitaliFace.jpeg",         //OCT
    "./assets/website/remyVitali.jpeg",             //NOV
    "./assets/website/remyVitaliPhoto.jpeg"         //DEC
][date.getMonth()];


const sharable = navigator.share !== undefined;

export const PersonalPage = ({ toggleSwap }) => {
    const messages = {
        shareTitle: useIntl().messages.shareTitle,
        shareText: useIntl().messages.shareText
    }
    const shareHandler = () => {
        navigator.share && navigator.share({
            title: messages.shareTitle,
            text: messages.shareText,
            url: 'https://saison.one/remyjeuniaux',
          });
    }
    useEffect(() => {
        document.querySelector("footer").classList.add("blackFooter");
        return () => {
            document.querySelector("footer").classList.remove("blackFooter");
        }
    });

    return (<>
            <div className="swapWeb">
                <p className="hiddenTextForFutureIndexation"><FormattedMessage id="hiddenTextForFutureIndexation2"/></p>
                <div className="about_container">
                    <div>
                        <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitali.jpeg"/>
                        <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliAmand.jpeg"/>
                        <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliFace.jpeg"/>
                        <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliPortrait.jpeg"/>
                        <img draggable="false" alt="Remy Amand" src={image}/>
                        <div className="about_mask"/>
                    </div>
                    <div>
                        <h3><FormattedMessage id="title_aboutme"/></h3>
                        <p><FormattedMessage id="text_home_1" values={{rtn: <br/>}}/></p>
                        <p><FormattedMessage id="text_home_2" values={{rtn: <br/>}}/></p>
                        <p><FormattedMessage id="text_home_4" values={{link: <span className="portfolioLink" onClick={() => toggleSwap("portfolio")}><Link to={"../portfolio"}><FormattedMessage id="link_this"/></Link> .</span>}}/></p>
                        <p><FormattedMessage id="text_home_5" values={{rtn: <br/>, link: <span><Link to={"../photography"}><FormattedMessage id="link_here"/></Link></span>}}/></p>
                    </div>
                </div>
                <div className="maxContainer">
                    <h3><FormattedMessage id="title_services"/></h3>
                    <p><FormattedMessage id="text_home_3" values={{rtn: <br/>}}/></p>
                </div>
                <div className="align-center" style={{flexWrap: "wrap"}}>
                    <p className="exampleItem align-center"><img draggable="false" height="130" alt="" src="./assets/website/visitCard.jpg"/><small><FormattedMessage id="visitCard"/></small></p>
                    <p className="exampleItem align-center"><img draggable="false" height="130" alt="" src={assetsMap.layoutExampleMini.file}/><small><FormattedMessage id="layout"/></small></p>
                    <p className="exampleItem align-center"><img draggable="false" height="130" alt="" src={assetsMap.graphicDesignMini.file}/><small><FormattedMessage id="brandIdentity"/></small></p>
                </div>
                <p><FormattedMessage id="text_home_invite" values={{link: <Link to="../services"><FormattedMessage id="link_here"/></Link>}}/></p>
            </div>
            <div className="socialContainer">
                {window.isWinter && <div className="winterLayout"/>}
                <p className="hiddenTextForFutureIndexation"><FormattedMessage id="hiddenTextForFutureIndexation"/></p>
                <h5><FormattedMessage id="follow_me"/></h5>
                <div className="icons_container">
                    <a href="https://www.instagram.com/moonboy_creations/" target="_blank" rel="noreferrer">
                        <img draggable="false" height="70" alt="Instagram" src="./assets/icon_ig.png" />
                    </a>
                    <a href="https://www.behance.net/remyjeuniaux" target="_blank" rel="noreferrer">
                        <img draggable="false" style={{filter: "invert(var(--img-invert))"}} height="80" alt="Behance" src="./assets/icon_be.png" />
                    </a>
                </div>
                {
                    sharable &&
                    <div className="share_container" onClick={shareHandler}>
                        <img draggable="false" style={{background: "#101010", borderRadius: "5px", filter: "invert(var(--img-invert))"}} height="53" alt="Share" src="./assets/icon.svg" />
                        <span><FormattedMessage id="share"/></span>
                    </div>
                }
            </div>
            </>
    );
}